module.exports = __webpack_public_path__ + "img/page11.fad3ba0c.jpeg";